import { useEffect, useState } from "react";

const isApiReady = () => Boolean(window.api?.sync);

/**
 * Returns true once the Electron preload bridge has exposed window.api.
 * Preload registers api asynchronously after an IPC round-trip.
 */
export const useElectronApiReady = () => {
  const [ready, setReady] = useState(isApiReady);

  useEffect(() => {
    if (isApiReady()) {
      setReady(true);
      return;
    }

    const markReady = () => {
      if (isApiReady()) {
        setReady(true);
      }
    };

    window.addEventListener("electron-api-ready", markReady);

    const interval = window.setInterval(() => {
      if (isApiReady()) {
        setReady(true);
        window.clearInterval(interval);
      }
    }, 100);

    return () => {
      window.removeEventListener("electron-api-ready", markReady);
      window.clearInterval(interval);
    };
  }, []);

  return ready;
};
